import { render, staticRenderFns } from "./ParesSimpleList.vue?vue&type=template&id=3547b45a&scoped=true&"
import script from "./ParesSimpleList.vue?vue&type=script&lang=js&"
export * from "./ParesSimpleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547b45a",
  null
  
)

export default component.exports